/*
 * oo-myshoes-share.js  (OLD ORDER JAPAN / マイシューズ「画像で保存」)
 * 依存ライブラリなし・ES5 の書き方（古い iPhone Safari でも動くように）
 *
 * 呼び方:
 *   window.ooMyShoesShare({
 *     items: [{ img: '画像URL', title: '商品名' }, ...],   // 最大9足
 *     bgUrl: '背景画像URL（無くてもよい）',
 *     logoUrl: '公式ロゴの画像URL（透明PNG・無ければ文字）'
 *   });
 *   -> 1080x1350 の PNG を作り、共有シート（iPhone は「画像を保存」/インスタへ）
 *      → 使えなければダウンロード → それも無理なら画像を重ねて表示（長押しで保存）
 *
 *   window.ooMyShoesShare.render(opts, function (canvas, info) { ... });
 *   -> 絵を描くだけ（保存しない）。見本作りや試験用。
 *
 * 個人情報（名前・メール等）は画像にも記録にも入れない。title も画像には描かない。
 */
(function (window, document) {
  'use strict';

  var W = 1080, H = 1350;
  var COLS = 3, ROWS = 3, MAX = 9;
  var SIDE = 60;             // 左右の余白
  var SHELF_TOP = 60;        // 棚エリアの上
  var SHELF_BOTTOM = 1080;   // 棚エリアの下（3段目の棚板の位置）
  var ACCENT = '#00AEC7';    // OLD ORDER 公式カラー
  var IMG_TIMEOUT = 10000;   // 1枚あたりの待ち時間（ミリ秒）
  var FONT = '"Helvetica Neue", Helvetica, Arial, sans-serif';
  // 2026-10-25 窓口の指示: ケースの写真を上に縮めて置き、下に白い帯（220px）を作って文字はそこだけに入れる（棚や靴に文字を重ねない）
  var BAND = 220;                                  // 下の白い帯の高さ
  var PH = H - BAND;                               // ケースの写真の高さ（1130）
  var PW = Math.round(1080 * PH / 1350);           // ケースの写真の幅（904・縦横比はそのまま）
  var PX = Math.round((W - PW) / 2), PY = 0;       // ケースの写真の左上
  // 背景写真（showcase_portrait・1080×1350・3列×3段）の上の9マス（写真の中の割合）。写真を見て決めた値。
  //  x＝列の中心、floor＝靴を乗せる棚板の上の面、colW＝マスの幅、rowH＝靴の高さの上限。写真を変えたらここと oo-my-shoes.js の PHOTO を直す
  var SLOT = { x: [0.194, 0.5, 0.806], floor: [0.298, 0.567, 0.858], colW: 0.28, rowH: 0.19 };
  var SHOE_W = 0.82;                               // 靴の幅＝マスの幅の約8割

  /* ---------- 画像の読み込み ---------- */

  function normalizeUrl(url) {
    if (!url) return '';
    url = String(url);
    if (url.indexOf('//') === 0) url = 'https:' + url;
    // Shopify CDN は幅を指定して軽くする（すでに指定があればそのまま）
    if (url.indexOf('cdn.shopify.com') !== -1 && !/[?&]width=/.test(url)) {
      url += (url.indexOf('?') === -1 ? '?' : '&') + 'width=600';
    }
    return url;
  }

  function loadImage(url, cb) {
    var done = false;
    var img = new Image();
    var timer = setTimeout(function () { finish(null); }, IMG_TIMEOUT);
    function finish(result) {
      if (done) return;
      done = true;
      clearTimeout(timer);
      img.onload = img.onerror = null;
      cb(result);
    }
    if (!url) { finish(null); return; }
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      finish(img.naturalWidth || img.width ? img : null);
    };
    img.onerror = function () { finish(null); };
    img.src = url;
  }

  // すべて読み終わったら cb(画像の配列)。読めなかったものは null。
  function loadAll(urls, cb) {
    var results = [], left = urls.length, i;
    if (!left) { cb(results); return; }
    for (i = 0; i < urls.length; i++) {
      (function (idx) {
        loadImage(urls[idx], function (img) {
          results[idx] = img;
          left--;
          if (left === 0) cb(results);
        });
      })(i);
    }
  }

  /* ---------- 描画 ---------- */

  function drawCover(ctx, img, x, y, w, h) {
    var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height;
    var s = Math.max(w / iw, h / ih);
    var dw = iw * s, dh = ih * s;
    ctx.drawImage(img, x + (w - dw) / 2, y + (h - dh) / 2, dw, dh);
  }

  function rowHeight() { return (SHELF_BOTTOM - SHELF_TOP) / ROWS; }

  function drawDefaultBackground(ctx) {
    var g = ctx.createLinearGradient(0, 0, 0, H);
    g.addColorStop(0, '#ffffff');
    g.addColorStop(1, '#e9ebec');
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, W, H);

    // 3段の棚板（細い板＋下に薄い影）
    var rh = rowHeight(), r, y;
    for (r = 1; r <= ROWS; r++) {
      y = Math.round(SHELF_TOP + rh * r);
      ctx.fillStyle = '#d3d6d8';
      ctx.fillRect(SIDE - 20, y, W - (SIDE - 20) * 2, 10);
      ctx.fillStyle = '#b9bdc0';
      ctx.fillRect(SIDE - 20, y + 10, W - (SIDE - 20) * 2, 2);
      var sg = ctx.createLinearGradient(0, y + 12, 0, y + 40);
      sg.addColorStop(0, 'rgba(0,0,0,0.08)');
      sg.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = sg;
      ctx.fillRect(SIDE - 20, y + 12, W - (SIDE - 20) * 2, 28);
    }
  }

  // 商品写真の白い余白を切って、靴の写っている範囲だけを返す（失敗したら写真全体）
  function findShoeBox(img) {
    var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height;
    var full = { x: 0, y: 0, w: iw, h: ih };
    try {
      var s = Math.min(1, 300 / Math.max(iw, ih));
      var tw = Math.max(1, Math.round(iw * s)), th = Math.max(1, Math.round(ih * s));
      var c = document.createElement('canvas');
      c.width = tw; c.height = th;
      var cx = c.getContext('2d');
      cx.drawImage(img, 0, 0, tw, th);
      var d = cx.getImageData(0, 0, tw, th).data;
      var minX = tw, minY = th, maxX = -1, maxY = -1, x, y, p;
      for (y = 0; y < th; y++) {
        for (x = 0; x < tw; x++) {
          p = (y * tw + x) * 4;
          if (d[p + 3] > 20 && (d[p] < 238 || d[p + 1] < 238 || d[p + 2] < 238)) {
            if (x < minX) minX = x;
            if (x > maxX) maxX = x;
            if (y < minY) minY = y;
            if (y > maxY) maxY = y;
          }
        }
      }
      if (maxX < 0) return full;
      var m = 3; // 少しだけ余白を残す
      minX = Math.max(0, minX - m); minY = Math.max(0, minY - m);
      maxX = Math.min(tw - 1, maxX + m); maxY = Math.min(th - 1, maxY + m);
      return { x: minX / s, y: minY / s, w: (maxX - minX + 1) / s, h: (maxY - minY + 1) / s };
    } catch (e) {
      return full; // 画像が CORS 不可などで読めない時は切らずに使う
    }
  }

  // マスの中に縦横比を保って収める。靴は棚板の上に乗るよう下そろえ。
  function drawShoe(ctx, img, index) {
    var rh = rowHeight();
    var cw = (W - SIDE * 2) / COLS;
    var col = index % COLS, row = Math.floor(index / COLS);
    var pad = 14;
    var boxX = SIDE + cw * col + pad;
    var boxW = cw - pad * 2;
    var boxH = rh - 40;                              // 上に少しすき間
    var floorY = SHELF_TOP + rh * (row + 1) - 4;     // 棚板の少し上
    var b = findShoeBox(img);
    var s = Math.min(boxW / b.w, boxH / b.h);
    var dw = b.w * s, dh = b.h * s;
    var dx = boxX + (boxW - dw) / 2;
    var dy = floorY - dh;
    ctx.save();
    // 白背景の商品写真を背景になじませる（古いブラウザで未対応なら普通に描く）
    try { ctx.globalCompositeOperation = 'multiply'; } catch (e) {}
    ctx.drawImage(img, b.x, b.y, b.w, b.h, dx, dy, dw, dh);
    ctx.restore();
  }

  // 背景写真の上の9マスに置く（写真を縮めた分も合わせる）。靴の写っている範囲だけを切り出して、棚板の上に下そろえ
  function drawShoeOnPhoto(ctx, img, index) {
    var col = index % COLS, row = Math.floor(index / COLS);
    var boxW = SLOT.colW * PW * SHOE_W;
    var boxH = SLOT.rowH * PH;
    var cx = PX + SLOT.x[col] * PW;
    var floorY = PY + SLOT.floor[row] * PH;
    var b = findShoeBox(img);
    var s = Math.min(boxW / b.w, boxH / b.h);
    var dw = b.w * s, dh = b.h * s;
    ctx.save();
    try { ctx.globalCompositeOperation = 'multiply'; } catch (e) {}
    ctx.drawImage(img, b.x, b.y, b.w, b.h, cx - dw / 2, floorY - dh, dw, dh);
    ctx.restore();
  }

  // 文字間をあけて中央に描く（ctx.letterSpacing は古い Safari に無いので自前）
  function drawSpacedCenter(ctx, text, cx, y, spacing) {
    var chars = String(text).split(''), widths = [], total = 0, i, x;
    for (i = 0; i < chars.length; i++) {
      widths[i] = ctx.measureText(chars[i]).width;
      total += widths[i] + (i < chars.length - 1 ? spacing : 0);
    }
    x = cx - total / 2;
    ctx.textAlign = 'left';
    for (i = 0; i < chars.length; i++) {
      ctx.fillText(chars[i], x, y);
      x += widths[i] + spacing;
    }
  }

  // 幅に収まらなければ文字を小さくする
  function fitFont(ctx, text, weight, size, maxW, spacing) {
    var w;
    do {
      ctx.font = weight + ' ' + size + 'px ' + FONT;
      w = ctx.measureText(text).width + spacing * (String(text).length - 1);
      if (w <= maxW) break;
      size -= 2;
    } while (size > 12);
  }

  // 2026-10-25 会長の指示: 帯は「MY SHOES」→ 公式ロゴの画像（幅は画像の約40%）→ 小さく「oldorder.jp」。水色の線はロゴと色がかぶるので外す
  //  ロゴは opts.logoUrl（本番はテーマの assets/oo-myshoes-logo.png を asset_url で渡す）。読めなかったときだけ文字で代わりに出す
  var LOGO_W = Math.round(W * 0.37);
  function drawFooter(ctx, logo) {
    var cx = W / 2;
    ctx.save();
    ctx.globalCompositeOperation = 'source-over';
    // 下の白い帯（ここより上には文字を描かない）
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, PH, W, BAND);
    ctx.fillStyle = '#111111';
    ctx.textBaseline = 'alphabetic';

    fitFont(ctx, 'MY SHOES', 'bold', 54, W - SIDE * 2, 8);
    drawSpacedCenter(ctx, 'MY SHOES', cx, PH + 58, 8);

    if (logo) {
      var lw = LOGO_W, lh = Math.round(lw * (logo.naturalHeight || logo.height) / (logo.naturalWidth || logo.width));
      ctx.drawImage(logo, Math.round(cx - lw / 2), PH + 74, lw, lh);
    } else {
      ctx.fillStyle = '#13a1bb';
      fitFont(ctx, 'OLD ORDER JAPAN', 'bold', 30, W - SIDE * 2, 6);
      drawSpacedCenter(ctx, 'OLD ORDER JAPAN', cx, PH + 150, 6);
    }

    ctx.fillStyle = '#555555';
    fitFont(ctx, 'oldorder.jp', 'normal', 19, W - SIDE * 2, 2);
    drawSpacedCenter(ctx, 'oldorder.jp', cx, PH + 204, 2);
    ctx.restore();
  }

  function render(opts, cb) {
    opts = opts || {};
    var items = (opts.items || []).slice(0, MAX);
    var canvas = document.createElement('canvas');
    canvas.width = W;
    canvas.height = H;
    var ctx = canvas.getContext('2d');
    var urls = [], i;
    for (i = 0; i < items.length; i++) urls.push(normalizeUrl(items[i] && items[i].img));

    loadImage(normalizeUrl(opts.bgUrl), function (bg) {
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, W, H);
      if (bg) {
        drawCover(ctx, bg, PX, PY, PW, PH);
      } else {
        drawDefaultBackground(ctx);
      }
      loadAll(urls, function (imgs) {
        var placed = 0, skipped = 0;
        for (i = 0; i < imgs.length; i++) {
          if (imgs[i]) {
            try { if (bg) drawShoeOnPhoto(ctx, imgs[i], placed); else drawShoe(ctx, imgs[i], placed); placed++; } catch (e) { skipped++; }
          } else {
            skipped++;
          }
        }
        loadImage(normalizeUrl(opts.logoUrl), function (logo) {
          drawFooter(ctx, logo);
          cb(canvas, { placed: placed, skipped: skipped, bgUsed: !!bg, logoUsed: !!logo });
        });
      });
    });
  }

  /* ---------- PNG にして保存 ---------- */

  function dataUrlToBlob(dataUrl) {
    var parts = dataUrl.split(','), bin = atob(parts[1]);
    var len = bin.length, arr = new Uint8Array(len), i;
    for (i = 0; i < len; i++) arr[i] = bin.charCodeAt(i);
    return new Blob([arr], { type: 'image/png' });
  }

  function toBlob(canvas, cb) {
    if (canvas.toBlob) {
      canvas.toBlob(function (b) { cb(b || dataUrlToBlob(canvas.toDataURL('image/png'))); }, 'image/png');
    } else {
      cb(dataUrlToBlob(canvas.toDataURL('image/png')));
    }
  }

  function makeFile(blob) {
    try { return new File([blob], 'my-shoes.png', { type: 'image/png' }); } catch (e) { return null; }
  }

  function canShareFile(file) {
    return !!(file && navigator.share && navigator.canShare && navigator.canShare({ files: [file] }));
  }

  function download(blob) {
    var a = document.createElement('a');
    if (typeof a.download === 'undefined' || !window.URL || !URL.createObjectURL) return false;
    var url = URL.createObjectURL(blob);
    a.href = url;
    a.download = 'my-shoes.png';
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    setTimeout(function () { document.body.removeChild(a); URL.revokeObjectURL(url); }, 4000);
    return true;
  }

  // 最後の手段: 画像を重ねて表示（iPhone は長押し→「"写真"に保存」）
  // 共有ボタンも置く（このタップは「その場の操作」になるので共有シートが開ける）
  function showOverlay(canvas, file) {
    var old = document.getElementById('oo-myshoes-share-overlay');
    if (old) old.parentNode.removeChild(old);
    var wrap = document.createElement('div');
    wrap.id = 'oo-myshoes-share-overlay';
    wrap.setAttribute('style', 'position:fixed;left:0;top:0;right:0;bottom:0;z-index:2147483000;' +
      'background:rgba(0,0,0,0.85);overflow:auto;-webkit-overflow-scrolling:touch;text-align:center;padding:16px;box-sizing:border-box;');
    var img = document.createElement('img');
    img.src = canvas.toDataURL('image/png');
    img.alt = 'MY SHOES';
    img.setAttribute('style', 'display:block;margin:0 auto;max-width:100%;max-height:72vh;height:auto;background:#fff;');
    var note = document.createElement('p');
    note.appendChild(document.createTextNode('画像を長押しすると保存できます'));
    note.setAttribute('style', 'color:#fff;font-size:14px;margin:12px 0;');
    wrap.appendChild(img);
    wrap.appendChild(note);
    if (canShareFile(file)) {
      var sb = document.createElement('button');
      sb.type = 'button';
      sb.appendChild(document.createTextNode('保存・シェアする'));
      sb.setAttribute('style', 'font-size:16px;padding:12px 24px;margin:0 6px 8px;border:0;background:' + ACCENT + ';color:#fff;border-radius:4px;');
      sb.onclick = function () { navigator.share({ files: [file] })['catch'](function () {}); };
      wrap.appendChild(sb);
    }
    var cb = document.createElement('button');
    cb.type = 'button';
    cb.appendChild(document.createTextNode('閉じる'));
    cb.setAttribute('style', 'font-size:16px;padding:12px 24px;margin:0 6px 8px;border:1px solid #fff;background:transparent;color:#fff;border-radius:4px;');
    cb.onclick = function () { wrap.parentNode.removeChild(wrap); };
    wrap.appendChild(cb);
    document.body.appendChild(wrap);
  }

  function save(canvas, done) {
    toBlob(canvas, function (blob) {
      var file = makeFile(blob);
      if (canShareFile(file)) {
        try {
          navigator.share({ files: [file] }).then(function () {
            if (done) done('shared');
          }, function (err) {
            // 自分でキャンセルした時は何もしない
            if (err && err.name === 'AbortError') { if (done) done('cancelled'); return; }
            // 画像の読み込みに時間がかかり「タップ直後」の扱いが切れた等 → 重ねて表示
            showOverlay(canvas, file);
            if (done) done('overlay');
          });
          return;
        } catch (e) { /* 下へ */ }
      }
      // iPhone の古い Safari は download 属性があっても新しいタブで開くだけのことがあるので重ねて表示
      var isIOS = /iP(hone|od|ad)/.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      if (!isIOS && download(blob)) { if (done) done('downloaded'); return; }
      showOverlay(canvas, file);
      if (done) done('overlay');
    });
  }

  function ooMyShoesShare(opts, done) {
    render(opts, function (canvas, info) {
      if (!info.placed) {
        if (done) done('empty', info);
        return;
      }
      save(canvas, function (how) { if (done) done(how, info); });
    });
  }

  ooMyShoesShare.render = render;
  ooMyShoesShare.save = save;
  window.ooMyShoesShare = ooMyShoesShare;
})(window, document);
